import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  API_DOWNLOAD_EXAMINATION_RESULT_FILE,
  API_INSPECTION_TECHNICAL_CONDITION_BASES,
  API_INSPECTION_TECHNICAL_CONDITION_BASES_ALL,
  MAIN_URL,
  PORT,
} from "../../constants/constants";
import {
  GET_INSPECTION_TECHNICAL_CONDITION_BASE,
  GET_INSPECTION_TECHNICAL_CONDITION_BASES,
  GET_INSPECTION_TECHNICAL_CONDITION_BASES_ALL,
  RESET_EXAMINATION_RESULT_FILE,
  SET_EXAMINATION_RESULT_FILE,
} from "../types";

export function getDataInspectionTechnicalConditionBasesPagination(
  params,
  page,
) {
  return async (dispatch) => {
    try {
      let url =
        MAIN_URL +
        PORT +
        API_INSPECTION_TECHNICAL_CONDITION_BASES +
        "page=" +
        page +
        "&size=10";

      if (params.startDate && !params.endDate) {
        url += `&startDate=${params.startDate}`;
      } else if (!params.startDate && params.endDate) {
        url += `&endDate=${params.endDate}`;
      } else if (params.startDate && params.endDate) {
        url += `&startDate=${params.startDate}&endDate=${params.endDate}`;
      }

      const response = await fetchWithToken(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      });

      if (!response) {
        return;
      }

      const data = await response.json();

      const processedData = data.content.map((item) => ({
        ...item,
        ownerAddressPhone: `${item.ownerAddress || ""}, ${item.phone1 || ""}`,
        locationPhone: `${item.location || ""}, ${item.phone2 || ""}`,
        id: item.parkId,
        checkDate: item.checkDate
          ? item.checkDate.split("-").reverse().join(".")
          : "",
      }));

      const savedData = data;
      savedData.content = processedData;

      dispatch({
        type: GET_INSPECTION_TECHNICAL_CONDITION_BASES,
        data: savedData,
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };
}

export function getDataInspectionTechnicalConditionBasesAll(params) {
  return async (dispatch) => {
    try {
      let url = MAIN_URL + PORT + API_INSPECTION_TECHNICAL_CONDITION_BASES_ALL;

      if (params.startDate && !params.endDate) {
        url += `&startDate=${params.startDate}`;
      } else if (!params.startDate && params.endDate) {
        url += `&endDate=${params.endDate}`;
      } else if (params.startDate && params.endDate) {
        url += `&startDate=${params.startDate}&endDate=${params.endDate}`;
      }

      const response = await fetchWithToken(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      });

      if (!response) {
        return;
      }

      const data = await response.json();
      const processedData = data.map((item) => ({
        ...item,
        ownerAddressPhone: `${item.ownerAddress || ""}, ${item.phone1 || ""}`,
        locationPhone: `${item.location || ""}, ${item.phone2 || ""}`,
        id: item.parkId,
        checkDate: item.checkDate
          ? item.checkDate.split("-").reverse().join(".")
          : "",
      }));
      dispatch({
        type: GET_INSPECTION_TECHNICAL_CONDITION_BASES_ALL,
        data: processedData,
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };
}

export const setDataForTableConditionBases = (data) => {
  return {
    type: GET_INSPECTION_TECHNICAL_CONDITION_BASE,
    selectedObject: data,
  };
};

export const getExaminationResultFile = (baseId, checkDoc) => {
  return async (dispatch) => {
    const fileRequest = await fetchWithToken(
      MAIN_URL + PORT + API_DOWNLOAD_EXAMINATION_RESULT_FILE + checkDoc,
    );
    const data = await fileRequest;

    if (fileRequest.status !== 200) {
    } else {
      dispatch({
        type: SET_EXAMINATION_RESULT_FILE,
        data: data,
      });
    }
  };
};

export const restExaminationResultFile = () => {
  return {
    type: RESET_EXAMINATION_RESULT_FILE,
    data: null,
  };
};
